/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Assign IPv4 — subnet 192.168.168.192/28</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/7</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1R1Items" :key="'t1-r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task1R2Items" :key="'t1-r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R1</span>
              <div class="space-y-1 ml-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion.pingV4)"></div>
                  <code class="text-base" :class="r1Completion.pingV4?'text-success':''">ping 192.168.168.206</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Assign IPv6 — prefix 2001:db8:12::60/125</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/5</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R1Items" :key="'t2-r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R2Items" :key="'t2-r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R1</span>
              <div class="space-y-1 ml-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion.pingV6)"></div>
                  <code class="text-base" :class="r1Completion.pingV6?'text-success':''">ping 2001:db8:12::67</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved,r2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rk in ['r1','r2']" :key="'s-'+rk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(rk).saved)"></div>
                    <code class="text-base" :class="getComp(rk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "end" to reach exec mode, then "ping" to verify connectivity.';

const mkCommands = (rk, vm) => ({
  help:       () => createStdout(HELP),
  enable:     () => vm.iosEnable(rk),
  configure:  (x) => vm.iosConfigure(rk, x),
  conf:       (x) => vm.iosConfigure(rk, x),
  interface:  (x) => vm.iosInterface(rk, x),
  int:        (x) => vm.iosInterface(rk, x),
  ip:         (x) => vm.iosIp(rk, x),
  ipv6:       (x) => vm.iosIpv6(rk, x),
  no:         (x) => vm.iosNo(rk, x),
  ping:       (x) => vm.iosPing(rk, x),
  exit:       () => vm.iosExit(rk),
  end:        () => vm.iosEnd(rk),
  copy:       (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/IPv4_and_IPv6_Assignment_Sim_2.png',
      sel: 'r1',
      totalScore: 0,

      r1: { mode: 'exec', currentIf: null },
      r2: { mode: 'exec', currentIf: null },

      // r1: task1(4) + task2(3) + saved(1) = 8
      r1Completion: {
        e01IfT1: false, e01Ipv4: false, e01NoShut: false, pingV4: false,
        e01IfT2: false, e01Ipv6: false, pingV6: false,
        saved: false,
      },
      // r2: task1(3) + task2(2) + saved(1) = 6
      r2Completion: {
        e01IfT1: false, e01Ipv4: false, e01NoShut: false,
        e01IfT2: false, e01Ipv6: false,
        saved: false,
      },

      r1Commands: null,
      r2Commands: null,

      task1R1Items: [
        { key: 'e01IfT1',   label: 'interface e0/1' },
        { key: 'e01Ipv4',   label: 'ip address 192.168.168.193 255.255.255.240' },
        { key: 'e01NoShut', label: 'no shut' },
      ],
      task1R2Items: [
        { key: 'e01IfT1',   label: 'interface e0/1' },
        { key: 'e01Ipv4',   label: 'ip address 192.168.168.206 255.255.255.240' },
        { key: 'e01NoShut', label: 'no shut' },
      ],
      task2R1Items: [
        { key: 'e01IfT2', label: 'interface e0/1' },
        { key: 'e01Ipv6', label: 'ipv6 address 2001:db8:12::61/125' },
      ],
      task2R2Items: [
        { key: 'e01IfT2', label: 'interface e0/1' },
        { key: 'e01Ipv6', label: 'ipv6 address 2001:db8:12::67/125' },
      ],
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config-if') return 'R1(config-if)#';
      if (m === 'config')    return 'R1(config)#';
      return 'R1#';
    },
    r2Prompt() {
      const m = this.r2.mode;
      if (m === 'config-if') return 'R2(config-if)#';
      if (m === 'config')    return 'R2(config)#';
      return 'R2#';
    },

    // task1: r1(3) + r2(3) + pingV4(1) = 7
    task1Progress() {
      const c1 = this.r1Completion, c2 = this.r2Completion;
      return [c1.e01IfT1, c1.e01Ipv4, c1.e01NoShut, c1.pingV4,
              c2.e01IfT1, c2.e01Ipv4, c2.e01NoShut].filter(Boolean).length;
    },
    task1Done() { return this.task1Progress === 7; },

    // task2: r1(2) + r2(2) + pingV6(1) = 5
    task2Progress() {
      const c1 = this.r1Completion, c2 = this.r2Completion;
      return [c1.e01IfT2, c1.e01Ipv6, c1.pingV6,
              c2.e01IfT2, c2.e01Ipv6].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 5; },

    saveDone() { return this.r1Completion.saved && this.r2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/, '').replace(/^fastethernet/, '').replace(/^ethernet/, '')
        .replace(/^gi(?=\d)/, '').replace(/^fa(?=\d)/, '').replace(/^e(?=\d)/, '').replace(/^g(?=\d)/, '')
        .trim();
    },

    updateScore() {
      const score = Object.values(this.r1Completion).filter(Boolean).length +
                    Object.values(this.r2Completion).filter(Boolean).length;
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      // r1(8) + r2(6) = 14
      if (score >= 14) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosConfigure(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      const s = this[rk];
      if (s.mode === 'config-if') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; this[rk].currentIf = null; return createStdout(''); },

    iosInterface(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config' && s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in global or interface configuration mode');
      let _ifRaw = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _ifRaw = _ifRaw + x._[2];
      const ifNorm = this.normalizeIf(_ifRaw);
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this[rk + 'Completion'];
      if (ifNorm === '0/1') {
        if (!c.e01IfT1)      { c.e01IfT1 = true; this.updateScore(); }
        else if (!c.e01IfT2) { c.e01IfT2 = true; this.updateScore(); }
      }
      return createStdout('');
    },

    iosIp(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      if ((x._[1] || '').toLowerCase() !== 'address') return createStderr('% Invalid input detected');
      const ip   = (x._[2] || '');
      const mask = (x._[3] || '');
      const c    = this[rk + 'Completion'];
      if (s.currentIf === '0/1' && !c.e01Ipv4) {
        if (rk === 'r1' && ip === '192.168.168.193' && mask === '255.255.255.240') {
          c.e01Ipv4 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv4 192.168.168.193/28 assigned to R1 e0/1. Subnet 192.168.168.192/28 (increment 16) has 14 usable hosts — .193 is the first. ' +
            'The /28 mask (255.255.255.240) leaves 4 host bits: 16 total addresses, 14 usable. → "no shut" to bring the interface up.'
          ));
        }
        if (rk === 'r2' && ip === '192.168.168.206' && mask === '255.255.255.240') {
          c.e01Ipv4 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv4 192.168.168.206/28 assigned to R2 e0/1. This is the last usable host — 192.168.168.207 is the broadcast address and cannot be assigned. → "no shut" to bring the interface up.'
          ));
        }
      }
      return createStdout('');
    },

    iosIpv6(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      if ((x._[1] || '').toLowerCase() !== 'address') return createStderr('% Invalid input detected');
      const addr = (x._[2] || '').toLowerCase();
      const c    = this[rk + 'Completion'];
      if (s.currentIf === '0/1' && !c.e01Ipv6) {
        if (rk === 'r1' && addr === '2001:db8:12::61/125') {
          c.e01Ipv6 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv6 2001:db8:12::61/125 assigned to R1. The /125 prefix gives 2³=8 addresses: ::60 is the subnet router anycast address (do not assign). ' +
            '::61–::67 are the 7 usable host addresses — IPv6 has NO broadcast so all 7 are valid for hosts. → Configure R2\'s IPv6 address.'
          ));
        }
        if (rk === 'r2' && addr === '2001:db8:12::67/125') {
          c.e01Ipv6 = true; this.updateScore();
          return createStdout(this.guide(
            'IPv6 2001:db8:12::67/125 assigned to R2. This is the last address in the subnet — valid because IPv6 reserves no broadcast address. ' +
            '→ From R1\'s exec mode: "ping 2001:db8:12::67" to verify connectivity.'
          ));
        }
      }
      return createStdout('');
    },

    iosNo(rk, x) {
      const s = this[rk];
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      const sub1 = (x._[1] || '').toLowerCase();
      const c    = this[rk + 'Completion'];
      if ((sub1 === 'shut' || sub1 === 'shutdown') && s.currentIf === '0/1' && !c.e01NoShut) {
        c.e01NoShut = true; this.updateScore();
        return createStdout(
          `%LINEPROTO-5-UPDOWN: Line protocol on Interface GigabitEthernet0/1, changed state to up` +
          this.guide(
            `${rk.toUpperCase()} e0/1 is now up. Router interfaces default to administratively shutdown — you must explicitly enable them with "no shutdown". ` +
            (rk === 'r1' && this.r2Completion.e01NoShut
              ? '→ Type "end" then "ping 192.168.168.206" to verify connectivity.'
              : rk === 'r1'
                ? '→ Configure R2\'s IPv4 address and bring up its interface, then ping from R1.'
                : '→ From R1\'s exec mode: "end" then "ping 192.168.168.206" to verify.')
          )
        );
      }
      return createStdout('');
    },

    iosPing(rk, x) {
      const s = this[rk];
      if (s.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const target = (x._[1] || '').toLowerCase();
      const c      = this[rk + 'Completion'];

      // IPv4 ping
      if (target === '192.168.168.206') {
        const ready = this.r1Completion.e01Ipv4 && this.r1Completion.e01NoShut &&
                      this.r2Completion.e01Ipv4 && this.r2Completion.e01NoShut;
        if (!ready) {
          return createStdout(
            'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 192.168.168.206, timeout is 2 seconds:<br>.....<br>Success rate is 0 percent (0/5)' +
            this.guide('Ping failed — ensure both R1 and R2 have their IPv4 addresses configured and interfaces brought up with "no shut".')
          );
        }
        const out = 'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 192.168.168.206, timeout is 2 seconds:<br>.!!!!</b><br>Success rate is 80 percent (4/5), round-trip min/avg/max = 1/2/4 ms';
        if (rk === 'r1' && !c.pingV4) {
          c.pingV4 = true; this.updateScore();
          return createStdout(out + this.guide(
            'Ping to R2 successful. The leading "." is ARP resolving R2\'s MAC; the four "!" confirm ICMP replies. ' +
            '→ Configure IPv6: "configure terminal" then "interface e0/1" then "ipv6 address 2001:db8:12::61/125".'
          ));
        }
        return createStdout(out);
      }

      // IPv6 ping
      if (target === '2001:db8:12::67') {
        const ready = this.r1Completion.e01Ipv6 && this.r2Completion.e01Ipv6;
        if (!ready) {
          return createStdout(
            'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 2001:DB8:12::67, timeout is 2 seconds:<br>.....<br>Success rate is 0 percent (0/5)' +
            this.guide('Ping failed — ensure both R1 and R2 have their IPv6 addresses configured.')
          );
        }
        const out = 'Type escape sequence to abort.<br>Sending 5, 100-byte ICMP Echos to 2001:DB8:12::67, timeout is 2 seconds:<br>!!!!!</b><br>Success rate is 100 percent (5/5), round-trip min/avg/max = 1/2/4 ms';
        if (rk === 'r1' && !c.pingV6) {
          c.pingV6 = true; this.updateScore();
          return createStdout(out + this.guide(
            'IPv6 ping to R2 successful — 100% (!!!!!). IPv6 NDP resolves link-layer addresses inline so all 5 packets succeed. ' +
            '→ Save both routers: "end" then "copy running-config startup-config".'
          ));
        }
        return createStdout(out);
      }

      return createStdout(
        'Type escape sequence to abort.<br>' +
        `Sending 5, 100-byte ICMP Echos to ${x._[1]}, timeout is 2 seconds:<br>.....<br>Success rate is 0 percent (0/5)`
      );
    },

    iosCopy(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${rk.toUpperCase()} configuration saved. ` + (this.saveDone ? '✓ Both routers saved — simulation complete!' : '→ Save the remaining router.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

